import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { PhraseGroup } from '../../interfaces/travel-guide.interface';

@Component({
  selector: 'fin-travel-guide-phrases',
  templateUrl: './travel-guide-phrases.component.html',
  styleUrls: ['./travel-guide-phrases.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TravelGuidePhrasesComponent {
  @Input()
  phraseGroup: PhraseGroup;
}
